document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('.valquimia_card__form');

  forms.forEach((form) => {
    form.addEventListener('submit', function (event) {
      event.preventDefault(); // no ir a /cart

      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      const formData = new FormData(form);

      // 1) Agregar al carrito por AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      })
        .then((res) => {
          if (!res.ok) throw new Error('Error al agregar al carrito');
          return res.json();
        })
        .then(() => {
          // 2) Usar la forma "oficial" de Horizon para refrescar y abrir el drawer
          return import('@theme/events').then(({ CartUpdateEvent }) => {
            const cartDrawer = document.querySelector('cart-drawer-component');

            return fetch('/cart.js')
              .then((res) => res.json())
              .then((cart) => {
                const event = new CartUpdateEvent(cart, 'manual-trigger', {
                  itemCount: cart.item_count,
                  source: 'valquimia-grid',
                  sections: {}
                });

                // Actualiza burbuja, drawer, etc.
                document.dispatchEvent(event);

                // Abre el drawer
                if (cartDrawer && typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                } else if (cartDrawer) {
                  cartDrawer.setAttribute('open', '');
                }
              });
          });
        })
        .catch((err) => {
          console.error('Error al agregar al carrito:', err);
          // Como fallback, si algo revienta, lo mandamos al carrito normal
          window.location.href = '/cart';
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });
});
